import React from "react";
import {
  cellState,
  Offering,
  StageColumn,
  StagePosition,
} from "../../config/offeringCatalog";
import MatrixCell from "../MatrixCell/MatrixCell";

interface OfferingRowProps {
  offering: Offering;
  columns: StageColumn[];
  currentStagePosition: StagePosition | null;
}

const OfferingRow: React.FC<OfferingRowProps> = ({
  offering,
  columns,
  currentStagePosition,
}) => {
  return (
    <>
      <div className="flex flex-col gap-1 px-4 py-3 border-b border-gray-200 dark:border-slate-700">
        <span className="text-sm text-gray-900 dark:text-slate-100">
          {offering.name}
        </span>
        {offering.description && (
          <span className="text-xs text-gray-600 dark:text-slate-400">
            {offering.description}
          </span>
        )}
      </div>

      {columns.map((column) => {
        const state = cellState(offering, column.position);
        const included = state !== "not-included";
        return (
          <MatrixCell
            connectLeft={state === "carried"}
            connectRight={included && column.position < 4}
            highlighted={currentStagePosition === column.position}
            key={column.position}
            kind="stage"
            stagePosition={column.position}
            state={state}
          />
        );
      })}

      <MatrixCell alaCarte={offering.alaCarte} kind="alacarte" />
    </>
  );
};

export default OfferingRow;
